export default {
    'INVOP-CYCLEINVENTORY-INVENTRORYSTATIST': {
        key: 'invop-cycleInventory-inventoryStatist',
        label: '在库-循环盘点-盘点单统计'
      },
      'INVOP-CYCLEINVENTORY-INVENTRORYSTATIST-EXPORT': {
        key: 'invop-cycleInventory-inventoryStatist-export',
        label: '在库-循环盘点-盘点单统计-导出'
      },
      'INVOP-CYCLEINVENTORY-CHECKDETAIL': {
        key: 'invop-cycleInventory-checkDetail',
        label: '在库-循环盘点-差异明细'
      },
      'INVOP-CYCLEINVENTORY-CHECKDETAIL-EXPORT': {
        key: 'invop-cycleInventory-checkDetail-export',
        label: '在库-循环盘点-差异明细-导出'
      },
      'INVOP-CYCLEINVENTORY-CHECKDETAIL-RETURN': {
        key: 'invop-cycleInventory-checkDetail-return',
        label: '在库-循环盘点-差异明细-返回'
      },
      'INVOP-CYCLEINVENTORY-TASKASSIGN': {
        key: 'invop-cycleInventory-taskAssign',
        label: '在库-循环盘点-任务分配'
      },
      'INVOP-CREATEINVENTORY-CLICK': {
        key: 'invop-createInventory-click',
        label: '在库-新建盘点单-点击'
      },
      'INVOP-GENERATORINVENTORY-CLICK': {
        key: 'invop-generatorInventory-click',
        label: '在库-生成盘点单-点击'
      },
      'INVOP-GENERATORINVENTORY-ASSIGN': {
        key: 'invop-generatorInventory-taskAssign',
        label: '在库-盘点单-任务分配'
      }
}